<template>
  <div>
    <button
      type="button"
      class="btn btn-sm btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Inward
    </button>

    <a-modal v-model="visible" title="Pocket Money Inward Transaction" :width="this.settings['isMobileView'] ? 480 : 720">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
        <a-button key="submit" type="primary" htmlType="submit" :loading="loading" @click="handleSubmit">Submit</a-button>
      </template>

      <a-form class="mb-4" :form="form">

        <div class="row">
          <div class="col-12 col-md-12">
            <a-form-item label="Select Student">
              <a-select
                placeholder="Select Student"
                v-decorator="['hostel_enrollment_id', { rules: [{ required: true, message: 'Please select a Student!' } ] }]"
                @change="getStudents"
              >
                <a-select-option v-for="student in selectedStudent" :key="student.id" :value="student.id">
                  {{ student.name + '|' + student.student_code +'|' + student.hostel + '|' + student.block + '|' + student.room }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <a-form-item label="Amount">
              <a-input-number
                style="width: 100%" :min="0"
                v-decorator="['amount', { initialValue: '0' }, { rules: [{ required: true, message: 'Please input amount!' }] }]" />
            </a-form-item>
          </div>
          <div class="col-12 col-md-6">
            <a-form-item label="Date">
              <a-date-picker
                style="width: 100%"
                v-decorator="['date', { rules: [{ required: false, message: 'Please input date' }], initialValue: moment() },]"
                :format=dateFormat />
            </a-form-item>
          </div>
        </div>
        <a-form-item label="Remark">
          <a-textarea placeholder="remark" :autosize="{minRows: 2}" v-decorator="['remark']" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'inwardPocketMoneyModal',
  props: {
    formVisible: { type: Boolean, require: true },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      selectedHostel: [],
      selectedStudent: [],
      selectedFacility: [],
      selectedStaff: [],
      dateFormat: 'DD-MM-YYYY',
    }
  },
  mounted: function () {
    this.getHostels()
    this.getStudents()
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  watch: {
    formVisible: function(n, o) {
      this.visible = n
    },
  },
  methods: {
    moment,
    getHostels: function() {
      this.$http.get(`/api/hostel`)
        .then(({ data }) => {
          this.selectedHostel = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getStudents: function() {
      this.$http.get(`/api/hostel/enrollment/students`)
        .then(({ data }) => {
          this.selectedStudent = data.data.map(student => ({
            id: student.hostel_enrollment_id,
            name: student.student,
            student_code: student.student_code,
            hostel: student.hostel,
            block: student.block,
            room: student.room,
          }))
        })
        .catch(error => {
          console.log(error)
        })
    },
    showModal() {
      this.visible = true
      this.getHostels()
      this.getStudents()
    },
    handleCancel(e) {
      this.visible = false
    },
    handleSubmit(e) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.amount}?`,
            content: `Click on the OK button to add the pocket money!`,
            onOk: () => {
              this.$nprogress.start()
              this.$http
                .post('/api/hostel/pocket-money/inward', {
                  hostel_id: values.hostel_id,
                  hostel_enrollment_id: values.hostel_enrollment_id,
                  amount: values.amount,
                  date: values.date,
                  remark: values.remark,
                })
                .then((data) => {
                  this.visible = false
                  this.$emit('created')
                  this.form.resetFields()
                  this.$nprogress.done()
                  this.$notification['success']({
                    message: 'Pocket Money successfully added!',
                    description: `Pocket Money ${values.amount} added successfully!`,
                  })
                })
                .catch(error => {
                  this.$nprogress.done()
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              console.log('Cancel')
            },
          })
        }
      })
    },
  },
}
</script>
